import React from 'react';
import PropTypes from 'prop-types';
import SelectField from 'components/input/SelectField/SelectField';
import SubmitButton from 'components/button/SubmitButton';
import compose from 'recompose/compose';
import translate from 'components/hoc/translate';
import validations from 'helpers/forms/validations';
import { ButtonWrapper, FormWrapper, Item, Row, Section } from 'components/ui/table/elements';
import { Field, reduxForm } from 'redux-form';
import RenderPriceInputField from 'components/form/InputFields/RenderPriceInputField';

const UserWalletsCreateForm = (props) => {
    const {
        handleSubmit,
        handleSubmitForm,
        submitting,
        translate,
        currencies,
    } = props;

    return (
        <FormWrapper>
            <form onSubmit={ handleSubmit(handleSubmitForm) }>
                <Section>
                    <Row>
                        <Item>
                            <Field
                                choices={ currencies }
                                component={ SelectField }
                                floatingLabelFixed={ true }
                                label={ translate('fields.currency') }
                                optionText='name'
                                optionValue='code'
                                name='currency'
                                validate={ [
                                    validations.required,
                                ] }
                            />
                        </Item>
                    </Row>
                    <Row>
                        <Item>
                            <Field
                                component={ RenderPriceInputField }
                                floatingLabelFixed={ true }
                                fullWidth={ true }
                                label={ translate('resources.wallets.fields.balance') }
                                name='balance'
                                type='number'
                                validate={ [
                                    validations.required,
                                    validations.number,
                                ] }
                            />
                        </Item>
                    </Row>
                </Section>

                <Section>
                    <Row>
                        <ButtonWrapper>
                            <SubmitButton loading={ submitting } />
                        </ButtonWrapper>
                    </Row>
                </Section>
            </form>
        </FormWrapper>
    );
};

UserWalletsCreateForm.propTypes = {
    currencies: PropTypes.array.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    handleSubmitForm: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    translate: PropTypes.func.isRequired,
};

const enhance = compose(
    translate,
    reduxForm(),
);

export default enhance(UserWalletsCreateForm);


// WEBPACK FOOTER //
// ./src/pages/users/wallets/create/UserWalletsCreateForm.js